import React, { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import QuestionPreview from './QuestionPreview'
import { StyledErrorLabel } from '../style'

interface RadioProps {
  languageIndex: number
  type: string
  remove: (index: number) => void
  fields: any[]
  append: () => void
}

const Radio: React.FC<RadioProps> = (props) => {
  const { languageIndex, remove, append, fields } = props
  const { t } = useTranslation()
  const { control, setError, clearErrors, formState: { isSubmitted } } = useFormContext()
  const watchQuestions = useWatch({ control, name: `languages[${languageIndex}].question` })
  const watchAnwser = useWatch({ control, name: 'answers' })
  const watchReq = useWatch({ control, name: 'required' })

  useEffect(() => {
    if (fields.length < 2) {
      setError('answers', {
        message: t('Number of answers should be at least min. required ({{watchMin}})', { watchMin: 2 })
      })
    } else {
      clearErrors('answers')
    }
  }, [fields])

  function renderAnswers() {
    return <>
      {props.fields?.map((anwser, index) => {
        return <div key={anwser.key} style={{ display: 'flex', alignItems: 'center' }}>
          <FormFields.Input
            control={control}
            width={12}
            name={`answers[${index}].languages[${languageIndex}].answer`}
            label={t('Answer {{index}}', { index: index + 1 })}
            placeholder={t('Enter answer')}
            rules={{
              required: {
                value: true,
                message: t('Please enter anwser')
              }
            }}
          />
          <Form.Button
            style={{ marginLeft: 10, marginTop: 7 }}
            onClick={() => remove(index)}
            size={'small'}
            basic
            color='red'
            type={'button'}
            icon='trash'
          />
        </div>
      })}
      <Button
        type='button'
        style={{ color: 'white' }}
        content={t('Add')}
        icon='plus'
        labelPosition='left'
        onClick={() => append()}
      />
      {fields.length < 2 && isSubmitted && <StyledErrorLabel basic pointing>
        {t('Number of answers should be at least min. required ({{watchMin}})', { watchMin: 2 })}
      </StyledErrorLabel>}
    </>
  }

  function renderPreview() {
    return <QuestionPreview>
      <Form.Field label={watchQuestions} required={Boolean(watchReq)} />
      <div>
        {props.fields?.map((anwser) => {
          return <Form.Checkbox
            key={anwser.key}
            radio={props.type === 'radio'}
            label={anwser.languages[languageIndex].answer}
          />
        })}
      </div>
    </QuestionPreview>
  }

  return <>
    <FormFields.TextArea
      control={control}
      label={t('Type in your question')}
      placeholder={t('Type in your question')}
      name={`languages[${languageIndex}].question`}
      rules={{
        required: {
          value: true,
          message: t('Please enter question')
        }
      }}
    />
    {renderAnswers()}
    {renderPreview()}
  </>
}
export default Radio